import { render } from "./A5.vue?vue&type=template&id=53e67ff0&scoped=true"
import script from "./A5.vue?vue&type=script&lang=js"
export * from "./A5.vue?vue&type=script&lang=js"

import "./A5.vue?vue&type=style&index=0&id=53e67ff0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e67ff0"]])

export default __exports__